import { RFP_TYPE_PUBLIC_OFFERING_VALUE, RFP_TYPE_DIRECT_OFFER_VALUE, } from '@/utils/constants/rfp/rfpType';
/**
 * 公募案件か
 * @param rfpType
 * @returns {boolean}
 */
export const isRfpTypePublicOffer = (rfpType) => rfpType === RFP_TYPE_PUBLIC_OFFERING_VALUE;
/**
 * 直接案件か
 * @param rfpType
 * @returns {boolean}
 */
export const isRfpTypeDirectOffer = (rfpType) => rfpType === RFP_TYPE_DIRECT_OFFER_VALUE;
